
import React from 'react';
import { useNavigate } from 'react-router-dom';
import './styles/ViewAllSidebar.css';
import './styles/ViewAllSidebar.mobile.css';

export interface Subcategory {
  _id: string;
  name: string;
  slug: string;
  image?: string;
  isActive?: boolean;
}

interface ViewAllSidebarProps {
  subcategories: Subcategory[];
  activeSlug?: string;
}


const ViewAllSidebar: React.FC<ViewAllSidebarProps> = ({ subcategories = [], activeSlug }) => {
  const navigate = useNavigate();

  const handleSubcategoryClick = (slug: string) => {
    navigate(`/view-products/${slug}`);
  };

  return (
    <div className="view-all-sidebar">
      <div className="categories-list">
        {(subcategories || []).map((subcategory) => (
          <div
            key={subcategory._id}
            className={`category-item ${activeSlug === subcategory.slug ? 'active' : ''}`}
            onClick={() => handleSubcategoryClick(subcategory.slug)}
            style={{ cursor: 'pointer' }}
          >
            <img
              src={subcategory.image || 'https://ik.imagekit.io/raghav11/download.jpg?updatedAt=1757934662868'}
              alt={subcategory.name}
              className="category-icon"
            />
            <span className="category-name">{subcategory.name}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ViewAllSidebar;
